import {
  INTAKEMANAGELIST
} from 'actions/intakeManage';
import {reducerPackage} from "../../utils";
//取水口reducer
export const intakeManageList =  reducerPackage(INTAKEMANAGELIST);

